import authApiClient from './AuthClient';

const headers = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

const getUser = data => authApiClient.post('/token', data, { headers });

export default {
  getUser
};
